import React, { useContext } from 'react'
import { Box, Paper, styled, Typography } from '@mui/material'
import { TruncateText } from './../../../utils/TruncateText';
import HighlightText from '../../../utils/HighlightText';
import { ThemeContext } from '../../../context/ThemeContext';
import image from '../../../assets/images/common/Companyprofiles_CoverPage.jpg'


const CPCard = styled(Box)(({ theme }) => ({
  width: '32%',
  height: '65vh',
  margin: theme.spacing(2, 0),
  [theme.breakpoints.down('xl')]: {
    width: '40%',
    margin: theme.spacing(2, 3),
  },
  [theme.breakpoints.down('lg')]: {
    width: '45%',
    margin: theme.spacing(2, 0),
  },
  [theme.breakpoints.down('mdlg')]: {
    width: '48%',
  },
  [theme.breakpoints.down('md')]: {
    height: '80vh',
  },
  [theme.breakpoints.down('sm')]: {
    width: '80%',
  },
}));

const TitleText = styled(Typography)(({ theme }) => ({
  fontSize: '0.9rem',
  height: '50%',
  color: '#242424',
  fontWeight: 700,

  [theme.breakpoints.down('xxl')]: {
    fontSize: '0.8rem',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.9rem',
  },
}));

const InfoText = styled(Typography)(({ theme }) => ({
  fontSize: '0.8rem',
  height: '50%',

  [theme.breakpoints.down('xl')]: {
    fontSize: '0.8rem',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.8rem',
  },
}));

const PriceTypography = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: '900',
  
  [theme.breakpoints.down('xxl')]: {
    fontSize: '1.2rem',
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: '1rem',
  },
  [theme.breakpoints.down('sm')]: {
  },
}));



function CompanyProfileCard({ title, info, publishedOn, price, category }) {

  //handle title and info
  const { inputValue, setOpenPopUp } = useContext(ThemeContext);
  
  const truncatedTitle = TruncateText(title, 150);
  const truncatedInfo = TruncateText(info, 200);
  const highlightedTitle = HighlightText(truncatedTitle, inputValue);
  

  return (
    <CPCard>
      <Paper  sx={{ width: '100%', height: '100%', '&:hover': { boxShadow: 10, bgcolor: '#f4f4f4' }, }} >
        <Box sx={{ height: '35%' }} >
          <Box component="img" src={image} sx={{ width: '100%', height: '100%' }} />
        </Box>
        <Box sx={{ height: '50%', p: 1, }} >
          <TitleText onClick={() => setOpenPopUp(true)} sx={{ cursor: 'pointer' }} >{highlightedTitle}</TitleText>
          <InfoText>{truncatedInfo}</InfoText>
        </Box>
        <Box sx={{ height: '7%', p: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
          <Typography sx={{ fontSize: '0.9rem' }} >{publishedOn}</Typography>
          <PriceTypography>{price}</PriceTypography>
          <Typography sx={{ fontSize: '0.9rem' }} >{category}</Typography>
        </Box>
      </Paper>
    </CPCard>
  )
}

export default CompanyProfileCard
